// extracted by mini-css-extract-plugin
export default {"fontH1Size":"38px","magneticWallBannerOffset":"38px","minCommentHeight":"34px","postStateBarHeight":"42px","topbarHeight":"56px"};